import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import "./Spinner.css";
import "./hm-theme.css";

const AddExternalAccounts = ({ isOpen, onRequestClose }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    appname: "",
    validity: "",
    username: "",
  });
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const storedData = JSON.parse(localStorage.getItem("data"));
      if (!storedData || !storedData.token) {
        console.error("Token not found in localStorage");
        setLoading(false);
        return;
      }
      const token = storedData.token;

      await axios.post(`/api/externalaccount/create`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoading(false);
      toast.success("External account created successfully!");
      onRequestClose();
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  function rhandle(e) {
    const { id, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  }

  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (date) {
      const formattedDate = format(date, "dd/MMM/yyyy HH:mm:ss");
      setFormData((prevState) => ({
        ...prevState,
        validity: formattedDate,
      }));
    }
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">api</i>
          Add External Account
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="username" className="form-label small fw-semibold">
              Email Address <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              id="username"
              type="email"
              placeholder="account@domain.com"
              value={formData.username}
              onChange={rhandle}
              required
            />
          </div>

          <div className="mb-3">
            <label htmlFor="appname" className="form-label small fw-semibold">
              App Name <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              id="appname"
              type="text"
              placeholder="e.g. Partner Portal / Mobile App"
              value={formData.appname}
              onChange={rhandle}
              required
            />
          </div>

          <div className="mb-4">
            <label htmlFor="validity" className="form-label small fw-semibold d-block">
              Validity Date & Time <span className="text-danger">*</span>
            </label>
            <DatePicker
              selected={selectedDate}
              onChange={handleDateChange}
              showTimeSelect
              timeFormat="HH:mm:ss"
              timeIntervals={15}
              dateFormat="dd/MMM/yyyy HH:mm:ss"
              className="form-control w-100"
              placeholderText="Select validity expiry"
              required
            />
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
              Cancel
            </Button>
            <button type="submit" className="btn-hm-primary" disabled={loading}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>key</i>
              Create Account
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddExternalAccounts;
